export var indicatorDefaultTheme = {
  Root: {
    base: {
      fontFamily: '$typography.labelSmall.fontFamily',
      fontWeight: '$typography.labelSmall.fontWeight',
      fontSize: '$typography.labelSmall.fontSize',
      backgroundColor: '$color.error.main',
      color: '$color.neutral.00',
      width: 4,
      height: 4
    }
  }
};